import ajax from "../utils/request";
const actressApi = {
  /********************************活动列表*********************************** */
  // 女优列表
  queryActressList(params) {
    return ajax({
      url: "/actor/list",
      type: "get",
      params: params,
    });
  },
  // 新增女优
  addActress(params) {
    return ajax({
      url: "/actor/add",
      type: "post",
      params: params,
    });
  },

  //编辑女优
  editActress(params) {
    return ajax({
      url: "/actor/update",
      type: "post",
      params: params,
    });
  },

};

export default actressApi;